module.exports = __webpack_public_path__ + "img/spartan-carpentry-millwork-cabinetry-07-med.34246036.jpg";